angular.module('impactx.rfx').controller('RFXThreadViewSupplierCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'TranslationService',
    'RFXThreadSaveService',
    'ToolbarService',
    'ToastService',
    'BackService',
    RFXThreadViewSupplierCtrl
]);

function RFXThreadViewSupplierCtrl($scope, dataGen, $routeParams, TranslationService, RFXThreadSaveService, ToolbarService, ToastService, BackService) {
    $scope.threadId = $routeParams.id;
    var wasPrivate = false;

    dataGen.getData($scope, {
        id: $scope.threadId,
        rfqhId: $routeParams.rfqhId,
        supplierId: $routeParams.supplierId,
        isSupport: $routeParams.isSupport
    }, "/rfx/thread/view/supplier").then(function () {
        $scope.setButtons();
    });

    $scope.save = function () {
        return RFXThreadSaveService.saveData($scope).then(function () {
            RFXThreadSaveService.notifyUsers($scope.data.id, $scope.threadId == 0, true);
            BackService.back();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    $scope.setButtons = function () {
        wasPrivate = !$scope.data.isPublic.value;
        $scope.buttonDefinition = [
            {
                label: TranslationService.get("save"),
                action: $scope.save,
                type: 'validation',
                params: {form: $scope.dialogData},
                condition: canSave
            }
        ];

        ToolbarService.setButtons($scope.buttonDefinition);
    };

    $scope.onCommentAdded = function () {
        if ($scope.threadId > 0) {
            RFXThreadSaveService.saveData($scope).then(function () {
                RFXThreadSaveService.notifyUsers($scope.data.id, $scope.threadId == 0, true)
            });
            ToastService.openStandardToast($scope.trns.commentSaved);
        }
    };

    $scope.onAttachmentAdded = function () {
        if ($scope.threadId > 0) {
            RFXThreadSaveService.saveData($scope).then(function () {
                RFXThreadSaveService.notifyUsers($scope.data.id, $scope.threadId == 0, true)
            });
            ToastService.openStandardToast($scope.trns.attachmentSaved);
        }
    };

    function canSave() {
        return wasPrivate && $scope.data.isPublic.value;
    }
}